import { POLY_COUNT } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Maps a concrete polycount onto the Low/Medium/High button that represents it,
 * or undefined when it sits between the marks.
 *
 * @param {number} value - Target polycount.
 * @param {Object} range - { minimum, maximum, default }.
 * @returns {string|undefined} One of POLY_COUNT values.
 */
export function polyCountForValue(value, { minimum, maximum, default: defaultValue } = {}) {
  if (value === minimum) {
    return POLY_COUNT.LOW
  }
  if (value === maximum) {
    return POLY_COUNT.HIGH
  }
  if (value === defaultValue) {
    return POLY_COUNT.MEDIUM
  }

  return undefined
}
